'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

export type Tabs = 'dashboard' | 'tickets' | 'documents';

export interface TabsSlice {
  tab: Tabs;
}

const initialState: TabsSlice = { tab: 'dashboard' };

export const tabsSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    setTab: (state, actions: PayloadAction<Tabs>) => {
      state.tab = actions.payload;
    },
  },
});

export const { setTab } = tabsSlice.actions;
export const tabSelector = (state: RootState) => state.tabs.tab;
export default tabsSlice.reducer;
